<template>
  <div class="boxMultiEnderecos mt-4 mb-2">
    <div class="boxMultiEnderecos_header mb-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="Enderecos_header_title">
            Endereços
          </h2>
        </div>
      </div>
    </div>
    <div class="boxMultiEnderecos_enderecos mt-4 mb-3">
      <div v-if="enderecos.length">
        <p v-if="enderecos.length > 1">
          Existem {{ enderecos.length }} endereços cadastrados. Escolha qual deseja utilizar ou adicione outro.
        </p>

        <p v-else>
          Existe {{ enderecos.length }} endereço cadastrado. Utilize este ou adicione outro.
        </p>
      </div>

      <div v-for="(address, index) in enderecos"
           :key="index"
           class="col-12 boxMultiEnderecos_loop">
        <div class="row boxMultiEnderecos_endereco">
          <div class="custom-control custom-radio custom-control-inline">
            <div class="boxMultiEnderecos_local">
              <input :id="`endereco-${index}-${ _uid }`"
                     v-model="endereco_selected"
                     class="custom-control-input"
                     :name="`endereco-${index}-${ _uid }`"
                     type="radio"
                     :value="address"
                     @click="changeAtual(address, index)">
              <label class="custom-control-label"
                     :for="`endereco-${index}-${ _uid }`">{{ address | Endereco }}</label>
            </div>
          </div>
          <div class="pt-2">
            <button class="btn btn-default"
                    type="button"
                    @click="deleteAddress(address, index)">
              <IconSvg class="Excluir-icon icon--sm"
                       icon="trash" />
            </button>
            <button class="btn btn-default"
                    type="button"
                    @click="editAddress({...address, index: index, type: 'edit'})">
              <IconSvg class="Editar-icon icon--sm"
                       icon="pencil" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="enderecos.length">
      <div class="col-12">
        <div class="row boxMultiEnderecos_btns">
          <button v-b-modal="`modalEndereco_${_uid}`"
                  class="btn btn-outline-primary btn-options">
            Adicionar outro endereço
          </button>
        </div>
      </div>
    </div>

    <div v-if="exibirEnderecos && show_adresses == true && localData.type == 'new'"
         class="mb-3">
      <span v-if="propEnderecoRegistrado && Object.entries(propEnderecoRegistrado).length"
            class="custom-control custom-radio custom-control-inline">
        <input :id="`enderecoRegistrado_${ _uid }`"
               v-model="predefineAddress"
               type="radio"
               :value="propEnderecoRegistrado"
               name="propEnderecoRegistrado"
               class="custom-control-input"
               @change="getOtherAddress">
        <label class="custom-control-label"
               :for="`enderecoRegistrado_${ _uid }`">Utilizar o mesmo do registrado</label>
      </span>
      <span v-for="(genitor, index) in propEnderecosDisponiveis"
            :key="index"
            class="custom-control custom-radio custom-control-inline">
        <input :id="`enderecoGenitor-${genitor.pessoa.nome}-${_uid}-${index}`"
               v-model="predefineAddress"
               type="radio"
               name="enderecoGenitor"
               :value="genitor.pessoa.enderecos.find(endereco => endereco)"
               class="custom-control-input"
               @change="getOtherAddress">
        <label class="custom-control-label"
               :for="`enderecoGenitor-${genitor.pessoa.nome}-${_uid}-${index}`">O mesmo de {{ genitor.pessoa.nome }}</label>
      </span>
      <span class="custom-control custom-radio custom-control-inline">
        <input :id="`novoEndereco_${ _uid }`"
               v-model="predefineAddress"
               type="radio"
               :value="{}"
               name="novoEndereco"
               class="custom-control-input novo-enderecos"
               @change="newAddress">
        <label class="custom-control-label"
               :for="`novoEndereco_${ _uid }`">Novo</label>
      </span>
    </div>

    <div v-if="!enderecos.length">
      <BoxEndereco :no-header="true"
                   :data="localData"
                   :prop-mostrar-exterior="true"
                   @onEnderecoAdd="getAddress" />
      <div class="col-12">
        <div class="row boxMultiEnderecos_btns">
          <button class="btn btn-outline-dark btn-options"
                  @click="newAddress">
            Limpar endereço
          </button>
          <button class="btn btn-primary btn-options"
                  :disabled="!Object.values(localData).length"
                  @click="addAddress">
            Salvar endereço
          </button>
        </div>
      </div>
    </div>

    <b-modal :id="`modalEndereco_${_uid}`"
             :ref="`modalEndereco_${_uid}`"
             :title="localData.type == 'edit' ? 'Editando endereco' : 'Adicione um novo endereço'"
             centered
             size="xl"
             @ok="modalChanged"
             @hide="modalChanged">
      <div class="mt-3">
        <div v-if="exibirEnderecos && localData.type == 'new'"
             class="mb-3">
          <span v-if="propEnderecoRegistrado && Object.entries(propEnderecoRegistrado).length"
                class="custom-control custom-radio custom-control-inline">
            <input :id="`enderecoRegistrado_modal_${ _uid }`"
                   v-model="predefineAddress"
                   type="radio"
                   :value="propEnderecoRegistrado"
                   name="propEnderecoRegistrado_modal"
                   class="custom-control-input"
                   @change="getOtherAddress">
            <label class="custom-control-label"
                   :for="`enderecoRegistrado_modal_${ _uid }`">Utilizar o mesmo do registrado</label>
          </span>
          <span v-for="(genitor, index) in propEnderecosDisponiveis"
                :key="index"
                class="custom-control custom-radio custom-control-inline">
            <input :id="`enderecoGenitor-modal_${genitor.pessoa.nome}-${_uid}-${index}`"
                   v-model="predefineAddress"
                   type="radio"
                   name="enderecoGenitor_modal"
                   :value="genitor.pessoa.enderecos.find(endereco => endereco)"
                   class="custom-control-input"
                   @change="getOtherAddress">
            <label class="custom-control-label"
                   :for="`enderecoGenitor-modal_${genitor.pessoa.nome}-${_uid}-${index}`">O mesmo de {{ genitor.pessoa.nome }}</label>
          </span>
          <span class="custom-control custom-radio custom-control-inline">
            <input :id="`novoEndereco_modal_${ _uid }`"
                   v-model="predefineAddress"
                   type="radio"
                   :value="{}"
                   name="novoEndereco_modal"
                   class="custom-control-input novo-enderecos"
                   @change="newAddress">
            <label class="custom-control-label"
                   :for="`novoEndereco_modal_${ _uid }`">Novo</label>
          </span>
        </div>

        <BoxEndereco :no-header="true"
                     :data="localData"
                     :prop-mostrar-exterior="true"
                     @onEnderecoAdd="getAddress" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalAddGenitor_footer">
        <button class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button class="btn btn-sm btn-primary"
                type="submit"
                @click="addAddress">
          Continuar
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  // constants
  import BrazilianStates from "@/constants/brazilianStates"

  //Filters
  import { filterEndereco } from "@/filters/filters"

  //components
  import BoxEndereco from "./BoxEndereco"

  export default {
    name: 'BoxMultiEnderecos',
    components: { BoxEndereco },
    props: {
      propEnderecos: { type: Array, default: () => ([]) },
      propEnderecosDisponiveis: { type: Array, default: () => ([]) },
      propEnderecoRegistrado: { type: Object, default: () => ({}) },
      propCartorio: { type: Object, default: () => ({}) },
      propCpf: { type: Boolean, default: false },
      exibirEnderecos: { type: Boolean, default: false }
    },
    inject: ['$validator'],
    data () {
      return {
        localData: {
          cep: '',
          logradouro: '',
          numero: null,
          complemento: '',
          bairro: '',
          uf: '',
          cidade: '',
          codigo_pais: null,
          exterior: false
        },
        enderecos: [],
        endereco_selected: {},
        predefineAddress: {},
        paises: [],
        cidades: [],
        estados: [ ...BrazilianStates ],
        type: '',
        show_adresses: false
      }
    },
    watch: {
      propEnderecos () {
        this.enderecos = [...this.propEnderecos]

        this.predefineAddress = {}

        this.show_adresses = false
        //verifica o endereco atual para exibi-lo no form
        this.enderecos.forEach((endereco) => {
          this.endereco_selected = endereco
        })

        if (!this.enderecos.length) {
          this.init()
        }

        this.newAddress()
      },

      propCartorio () {
        if (!this.enderecos.length) {
          this.init()
        }
      }
    },
    mounted () {
      this.predefineAddress = {}

      if (this.propEnderecos.length) {
        this.enderecos = [...this.propEnderecos]

        this.enderecos.forEach((endereco) => {
          this.endereco_selected = endereco
        })
      } else {
        this.init()
      }

      this.newAddress()
    },
    methods: {
      modalChanged () {
        if (this.propCartorio && this.propCartorio.endereco) {
          this.localData = {
            uf: this.propCartorio.endereco.uf,
            cidade: this.propCartorio.endereco.cidade,
            ibge: this.propCartorio.endereco.ibge,
            type: 'new',
            atual: true
          }
        }
        else {
          this.localData = {
            type: 'new',
            atual: true
          }
        }

        this.show_adresses = false
      },
      init () {
        if (!this.enderecos.length) {
          if (this.propCartorio && this.propCartorio.endereco) {
            this.localData = {
              uf: this.propCartorio.endereco.uf,
              cidade: this.propCartorio.endereco.cidade,
              ibge: this.propCartorio.endereco.ibge,
              type: 'new',
              atual: true
            }
          }
          else {
            this.localData = {
              type: 'new',
              atual: true
            }
          }
        }

        this.show_adresses = true
      },
      changed () {
        this.$emit('changed', this.enderecos)
      },
      deleteAddress (endereco, index) {
        objSwal.question.title = 'Tem certeza que deseja excluir esse endereço?'
        objSwal.question.text = filterEndereco(endereco)
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        Swal.fire(objSwal.question).then((res) => {
          if (res.value) {
            this.enderecos.splice(index, 1)
            endereco.index = index
            this.$emit("deleteAddress", endereco)

            if (this.localData.index == index) {
              this.localData =  this.enderecos.find(address => address)
              this.localData.type = 'edit'
              this.localData.index = this.enderecos.length - 1

              this.endereco_selected = this.localData

              if (this.localData) this.localData.atual = true
            }

            this.changed()
          }
        })
      },
      editAddress (endereco) {
        this.localData = {...endereco}
        this.$root.$emit('bv::show::modal', `modalEndereco_${ this._uid }` )
      },
      addAddress () {
        this.$validator.validate('numero').then(resp => {
          if (resp && Object.values(this.localData).length) {

            if (this.localData.type == 'edit') {
              this.enderecos[this.localData.index] = this.localData
              this.$root.$emit('bv::hide::modal', `modalEndereco_${ this._uid }` )
              this.changed()
              return
            }

            const { cep, logradouro, numero, ibge, index, type } = this.localData

            let exist = false

            if (this.enderecos.length) {
              this.enderecos.forEach((endereco) => {
                if (cep == endereco.cep && logradouro == endereco.logradouro && numero == endereco.numero && ibge == endereco.ibge || index >= 0 || type == 'edit') {
                  exist = true
                }
              })
            }

            if (!exist && Object.values(this.localData).length > 2) {
              this.updateAtual()
              this.enderecos.push(this.localData)
              this.changed()
              this.$root.$emit('bv::hide::modal', `modalEndereco_${ this._uid }` )
            }
          }
        })
      },
      getAddress (endereco) {
        this.localData = endereco
      },
      changeAtual (endereco, index) {
        this.updateAtual()

        endereco.atual = true

        if (endereco) endereco.atual = true

        this.enderecos[index] = endereco

        this.changed()
      },
      updateAtual () {
        //verifica os enderecos atuais e troca flag atual para falso ao adicionar um novo endereco
        if (this.enderecos.length) {
          this.enderecos.forEach(endereco => {
            if (endereco.atual) endereco.atual = false
            if (endereco.atual) endereco.atual = false
          })
        }
      },
      getOtherAddress () {
        this.localData = { ...this.predefineAddress }
        this.localData.type = 'new'

        this.localData.atual = true
      },
      newAddress () {
        if (this.propCartorio && this.propCartorio.endereco) {
          this.localData = {
            uf: this.propCartorio.endereco.uf,
            cidade: this.propCartorio.endereco.cidade,
            ibge: this.propCartorio.endereco.ibge,
            type: 'new',
            atual: true,
          }
        }
        else {
          this.localData = {
            type: 'new',
            atual: true,
          }
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '../../scss/_utilities/_exports';

  .boxMultiEnderecos {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;
      padding-top: 15px;
      padding-bottom: 15px;
    }
    &_endereco {
      padding-left: 10px ;
      justify-content: space-between;
      align-items: center;
    }
    &_loop:nth-child(even) {
      background: #eaeaea;
    }
    &_loop:nth-child(odd) {
      background: #f5f4f4;
    }
    &_btns {
      justify-content: flex-end;
    }
  }

  .Enderecos {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }
    }
  }

  .Excluir {
      &-icon, svg {
        fill: #8b0000;
        width: 15px;
      }
  }

  .Editar {
      &-icon, svg {
        fill: #696969;
        width: 20px;
      }
  }

  .btn-options {
    margin: 10px;
  }

</style>
